module.exports = __webpack_public_path__ + "static/media/Supplementaries.935ba2a9.ogg";